import { axiosInstance } from "@/api/axiosInstance"

export const adminLogin = async (payload: {
    loginId: string
    password: string
}) => {
    const response = await axiosInstance.post("/api/admin/auth/login", payload)
    return response.data
}

export const adminLogout = async () => {
    const response = await axiosInstance.post("/api/admin/auth/logout")
    return response.data
}

export const getAdminMe = async () => {
    const response = await axiosInstance.get("/api/admin/auth/me")
    return response.data
}